/**
 * This is the application core service.
 * We register it via provider to be able to use it within module configurations.
 * It is part of the core module to be available to all other modules.
 * @memberOf Application Core Module
 * @namespace Application Core Service
 */

// Create the provider.
function coreServiceProvider() {
    // Register the factory.
    this.$get = ["$http", coreServiceFactory];
}

// Create the factory.
function coreServiceFactory($http) {
    // Create the service.
    return new CoreService($http);
}

/**
 * @name CoreService
 * @desc Create the service.
 * @memberOf Application Core Module.Application Core Service
 */
function CoreService($http) {

    // Instance context.
    var service = this;
  service.model = null;

    /**
     * @name Service.getIdentityModel
     * @desc Data Model from Identity Server.
     * @memberOf Application Core Module.Application Core Service
     * @returns object
     */
    service.getIdentityModel = function () {
        if (service.model){
            return service.model;
        }
        var modelJson = document.getElementById("modelJson");
        var encodedJson;
        if (modelJson.textContent) {
            encodedJson = modelJson.textContent;
        } else {
            encodedJson = modelJson.innerHTML;
        }
        var json = Encoder.htmlDecode(encodedJson);
        if(!json || !json.length){
            json = '{"model": ""}';
        }
        service.model = JSON.parse(json);
        return service.model;
    };

    service.updateIdentityModelLanguage = function (model) {
        var encodedJson = Encoder.htmlEncode(JSON.stringify(model));
        var modelJson = document.getElementById("modelJson");

        if (modelJson.textContent) {
            modelJson.textContent = encodedJson;
        } else {
            modelJson.innerHTML = encodedJson;
        }
    };

    service.getProductLanguages = function(siteUrl) {
        return $http.get(siteUrl + "selfService/productLanguages");
    };

    service.getCurrentProductLanguage = function() {
        var currentLanguage = {};
        var model = this.getIdentityModel();

        if (model && model.custom) {
            currentLanguage = model.custom.language;
        }
        return currentLanguage;
    };

    service.user = {name: ''};
}

export default coreServiceProvider;



// WEBPACK FOOTER //
// ./src/app.core.service.js